import { useEffect } from 'react';
import { ensureListing } from '../../../util/data';
import { createSlug, parse } from '../../../util/urlHelpers';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routeConfiguration';

export const useMalformedSlug = ({ history, params, listingId, getListing }) => {
    const { id, slug: propsSlug } = params;

    useEffect(() => {
        const listingDataLoaded = getListing(listingId);

        if (!listingDataLoaded) {
            return;
        }

        const currentListing = ensureListing(listingDataLoaded);

        const slug = createSlug(currentListing);
        const slugMalformed = slug !== propsSlug;

        if (slugMalformed) {
            const locationState = history?.location?.state;
            const locationSearch = history?.location?.search;
            const locationSearchData = parse(locationSearch || '');

            history.push(
                createResourceLocatorString(
                    'ListingPage',
                    routeConfiguration(),
                    { id, slug },
                    locationSearchData
                ),
                { state: locationState }
            );
        }
    }, [propsSlug, listingId]);
};
